import { render, staticRenderFns } from "./bodegas.vue?vue&type=template&id=37042cf9"
import script from "./bodegas.vue?vue&type=script&lang=js"
export * from "./bodegas.vue?vue&type=script&lang=js"
import style0 from "./bodegas.vue?vue&type=style&index=0&id=37042cf9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports